import React, {useCallback, useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';

import * as S from './Uploader.styles';

const Uploader = ({
  getUploadedFile,
  viewInvoice,
  gstFormValidFlag,
  clearGstFormData,
  heading,
  subHeading,
  additionalInfo,
  viewButtonMessage,
}) => {
  const [fls, setFls] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [myFiles, setMyFiles] = useState([]);
  const [error, setError] = useState('');
  console.log('myFiles', myFiles);
  const onDrop = useCallback(
    acceptedFiles => {
      setIsUploading(true);
      setError(''); // Clear any previous errors

      setFls(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      );

      setTimeout(() => {
        setIsUploading(false);
        setMyFiles([...myFiles, ...acceptedFiles]);
      }, 0);
    },
    [myFiles],
  );

  const onDropRejected = useCallback(rejectedFiles => {
    const rejectedFile = rejectedFiles?.[0];
    if (rejectedFile?.errors && rejectedFile?.errors?.length > 0) {
      const error = rejectedFile?.errors?.[0];
      if (error?.code === 'file-too-large') {
        setError(`File "${rejectedFile?.file?.name}" is too large. Maximum file size is 5 MB.`);
      } else if (error?.code === 'file-invalid-type') {
        setError(`File "${rejectedFile?.file?.name}" is not a valid PDF file.`);
      } else {
        setError(`Error uploading file "${rejectedFile?.file?.name}": ${error?.message}`);
      }
    }
  }, []);

  const {acceptedFiles, getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    onDropRejected,
    accept: {
      'application/pdf': ['.pdf'],
    },
    maxFiles: 1,
    maxSize: 5 * 1024 * 1024,
  });

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };

  const removeFile = file => () => {
    const newFiles = [...myFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
    clearGstFormData && clearGstFormData();
  };

  const setIcon = obj => {
    switch (obj.type) {
      case 'application/pdf':
        return <span className="sprite icPdf"></span>;
        break;
      default:
        <span className="sprite icPdf"></span>;
        break;
    }
  };

  useEffect(() => {
    if (fls.length > 0) {
      getUploadedFile && getUploadedFile(fls);
    }
  }, [fls]);

  const files = myFiles.map(file => (
    <S.UploadedFileItemCont key={file.path}>
      <S.UploadedFileItem /* isError={formatBytes(file.size) > '10 MB'} */>
        <S.FilteTypeIcon>{setIcon(file)}</S.FilteTypeIcon>
        <S.UploadedFileItemDesc>
          <S.FileName>{file.path}</S.FileName>
          <S.FileSize>{formatBytes(file.size)}</S.FileSize>
        </S.UploadedFileItemDesc>
        <S.ViewInvoice onClick={viewInvoice}>
          {viewButtonMessage ? viewButtonMessage : 'View invoice'}
        </S.ViewInvoice>
        <span className="sprite icMinus" onClick={removeFile(file)}></span>
      </S.UploadedFileItem>
      {/* {formatBytes(file.size) > '10 MB' && <S.ErrorMsg>File {file.path} could not be upload. File exceeds size limit.</S.ErrorMsg>} */}
    </S.UploadedFileItemCont>
  ));

  return (
    <S.UploadWrapper>
      <S.UploadContent>
        <S.UploadCont {...getRootProps()} multiple={false}>
          {myFiles.length === 0 && <input {...getInputProps()} />}
          <h4>{heading ? heading : 'Upload your GST invoice'}</h4>

          <h3 className="fs14 blackText mt5">
            {subHeading
              ? subHeading
              : `For faster approval and credit of the due GST amount use the invoice generated on
            myPartner`}
          </h3>
          <h3 className="fs14 blackText mt5">
            {additionalInfo
              ? additionalInfo
              : '(Invoice without signature & company stamp will be rejected)'}
          </h3>
          {myFiles.length === 0 && (
            <React.Fragment>
              <S.Drag>
                <img src={'https://assets-gos3.goibibo.com/myp_gst-1683207449.png'} />
              </S.Drag>
              <p className="fs14 blackText">
                Drag & drop your PDF files here or{' '}
                <span
                  className="latoBlack blueText"
                  style={{color: gstFormValidFlag ? '#008cff' : '#a8a8a8'}}
                >
                  choose file
                </span>
              </p>
              <p className="fs14 greyText mt5">5 MB max file size</p>
            </React.Fragment>
          )}
        </S.UploadCont>
        {myFiles.length > 0 && files}
      </S.UploadContent>
      {error && (
        <S.ErrorMsg style={{marginTop: '10px', color: '#d32f2f', fontSize: '14px'}}>
          {error}
        </S.ErrorMsg>
      )}
    </S.UploadWrapper>
  );
};

export default Uploader;
